/**
 * MenuSlotTabs
 * ────────────
 * Chip row that drives the active time-slot filter on every /menu
 * template. Defaults to the current clock-hour slot but lets the
 * customer flip between All / Breakfast / Lunch / Dinner so they can
 * preview the dinner menu while having breakfast at home.
 */
import { TIME_SLOTS } from "@/lib/useMenuData";

export default function MenuSlotTabs({ slot, onChange }) {
  return (
    <div
      data-testid="menu-slot-tabs"
      className="flex flex-wrap gap-2 justify-center"
    >
      {TIME_SLOTS.map((t) => {
        const on = slot === t.value;
        return (
          <button
            key={t.value}
            type="button"
            data-testid={`menu-slot-${t.value}`}
            onClick={() => onChange(t.value)}
            className={`rounded-full px-4 py-2 text-sm border transition-colors ${
              on
                ? "bg-[#121614] text-white border-[#121614]"
                : "bg-white text-[#121614] border-[#E8E5DF] hover:bg-[#F3F0EA]"
            }`}
          >
            {t.label}
          </button>
        );
      })}
    </div>
  );
}
